<div>
  <mat-toolbar class="container">
    <div class="image" [routerLink]="['home']"></div>
    <button class="button" mat-raised-button [routerLink]="['map']">
      MAPA
    </button>
    <button class="button" mat-raised-button [routerLink]="['list']">
      LISTA ZMARŁYCH
    </button>
    <mat-form-field appearance="fill" class="select">
      <mat-label>CMENTARZ</mat-label>
      <mat-select [formControl]="toppings" multiple (selectionChange)="filterByCemetery($event.value)">
        <mat-option *ngFor="let topping of toppingList" [value]="topping">{{topping}}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <button class="button" (click)="removeTestTombstones()">Dodaj 100 nagrobków</button> -->

  </mat-toolbar>
</div>
